import { MessageSquareText, Loader2 } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const COLS = ["Date", "Name", "Mobile", "Address", "Category", "Sub-type", "Solar", "PM Surya Ghar", "Bill / Load", "Lead", "Status", ""];
const STATUS_COLORS = { New: "text-sky-700", Contacted: "text-amber-700", Converted: "text-emerald-700" };

const fmtDate = (iso) => new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });

export const LeadsTable = ({ leads, loading, onStatus, onView }) => (
  <div className="glass mt-6 overflow-x-auto rounded-3xl" data-testid="admin-leads-table">
    <table className="w-full min-w-[1200px] text-left text-[15px]">
      <thead className="border-b border-slate-200 text-xs uppercase tracking-[0.14em] text-slate-500">
        <tr>{COLS.map((c, i) => <th key={i} className="px-4 py-4 font-semibold">{c}</th>)}</tr>
      </thead>
      <tbody>
        {loading && (
          <tr><td colSpan={COLS.length} className="py-16 text-center text-slate-500"><Loader2 className="mx-auto h-6 w-6 animate-spin" /></td></tr>
        )}
        {!loading && leads.length === 0 && (
          <tr><td colSpan={COLS.length} data-testid="admin-leads-empty" className="py-16 text-center text-slate-500">No leads found</td></tr>
        )}
        {!loading && leads.map((l) => (
          <tr key={l.id} data-testid={`admin-lead-row-${l.mobile}`} className="border-b border-slate-100 transition-colors hover:bg-slate-50">
            <td className="whitespace-nowrap px-4 py-3 text-slate-500">{fmtDate(l.updated_at)}</td>
            <td className="px-4 py-3 font-semibold text-navy-900">{l.name}</td>
            <td className="px-4 py-3"><a href={`tel:+91${l.mobile}`} className="text-gold-ink hover:underline">{l.mobile}</a></td>
            <td className="max-w-[200px] truncate px-4 py-3 text-slate-600" title={l.address}>{l.address || "–"}</td>
            <td className="px-4 py-3">{l.category || "–"}</td>
            <td className="px-4 py-3">{l.sub_type || "–"}</td>
            <td className="px-4 py-3">{l.solar_type || "–"}</td>
            <td className="px-4 py-3">{l.pm_interest || "–"}</td>
            <td className="px-4 py-3">{l.bill || "–"}</td>
            <td className="px-4 py-3">
              <span data-testid={`admin-lead-status-${l.mobile}`} className={`rounded-full px-2.5 py-1 text-xs font-bold uppercase ${l.status === "complete" ? "bg-emerald-500/15 text-emerald-700" : "bg-amber-500/15 text-amber-700"}`}>{l.status}</span>
            </td>
            <td className="px-4 py-3">
              <Select value={l.admin_status} onValueChange={(v) => onStatus(l.id, v)}>
                <SelectTrigger data-testid={`admin-lead-status-select-${l.mobile}`} className={`h-10 w-36 rounded-full bg-white ${STATUS_COLORS[l.admin_status]}`}><SelectValue /></SelectTrigger>
                <SelectContent>
                  {["New", "Contacted", "Converted"].map((s) => <SelectItem key={s} value={s} data-testid={`status-option-${s.toLowerCase()}`}>{s}</SelectItem>)}
                </SelectContent>
              </Select>
            </td>
            <td className="px-4 py-3">
              <button onClick={() => onView(l.id)} data-testid={`admin-view-transcript-${l.mobile}`} className="btn-ghost h-10 px-4 text-sm"><MessageSquareText className="h-4 w-4" /> Chat</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
